<template lang="pug">
	div
		#sfc-main-container
			sfc-sentry
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			#sfc-main-content
				nuxt
</template>

<style lang="stylus" scoped>
	.close-container
		max-width: 1140px
		width: 100%
		position: relative
		.close-x
			z-index 10000
			position: absolute
			top: 0
			right: 0
	#sfc-main-container
		margin-top: 0 !important
</style>
<script>

export default {
	
}
</script>
